import React from "react";
import { Button, ButtonProps } from "react-bootstrap";

// forwardRef so the component can be used as a child of MUI Tooltip, which needs to
// attach a ref to it. A plain function component cannot hold one.
const ButtonComponent = React.forwardRef<HTMLButtonElement, any>(
  ({ id = "", value, icon, disabled = false, ...rest }, ref) => {
    return (
      <button
        type="button"
        className={"btn-submit"}
        id={id}
        disabled={disabled}
        {...rest}
        ref={ref}
      >
        {icon && <i className={icon}> </i>} {value}
      </button>
    );
  }
);

ButtonComponent.displayName = "ButtonComponent";

export default ButtonComponent;
